// extracted by mini-css-extract-plugin
export default {"shieldBackground":"PolicyTemplateIcon_shieldBackground__Am3Ka","shield":"PolicyTemplateIcon_shield__pA9pU"};